import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { RdsDataAccessPolicyDialogData } from './data-access-policy-dialog-data.model';

/**
 * Based on the EulaDialogComponent from the data-collection-ui repository, refer to that to
 * see how the PDF previews were handled once file upload is supported.
 */
@Component({
  selector: 'rds-c-data-access-policy-dialog',
  templateUrl: './data-access-policy-dialog.component.html',
  styleUrls: ['./data-access-policy-dialog.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'rds-c-data-access-policy-dialog',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RdsDataAccessPolicyDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RdsDataAccessPolicyDialogData,
    public dialogRef: MatDialogRef<RdsDataAccessPolicyDialogComponent>
  ) {}

  handleDecision(userAgree: boolean) {
    this.dialogRef.close({
      agree: userAgree,
      dataAccessPolicy: this.data.dataAccessPolicy,
    });
  }
}
